import { createSelector } from 'reselect';
export const getAgent = (state: any) => state.getIn(['agent', 'AgentsInfo']);
export const getCities = (state: any) => state.getIn(['agent', 'cities']);
export const getIsLoadingCities = (state: any) =>
  state.getIn(['agent', 'isLoadingCities']);

const getAgentSelector = createSelector(getAgent, (agent) => agent);
const getCitiesSelector = createSelector(getCities, (cities) => cities);
const getIsLoadingCitiesSelector = createSelector(
  getIsLoadingCities,
  (isLoadingCities) => isLoadingCities,
);

export { getAgentSelector, getCitiesSelector, getIsLoadingCitiesSelector };
